/* OWNED BY THE FOUNDATION. */
import { Link } from "react-router-dom";
import { ContentError } from "../lib/content";
import { useI18n } from "../lib/i18n";

export function NotFound() {
  const { href, ui } = useI18n();
  return (
    <div className="catalog">
      <header className="cat-hero">
        <h1>{ui("notfound.title")}</h1>
        <p className="lead"><Link to={href("/")}>{ui("notfound.back")}</Link></p>
      </header>
    </div>
  );
}

/**
 * What a page shows when what it asked for did not arrive.
 *
 * The two are not the same thing and were being said with the same words. A
 * page whose address is wrong is not found; a page the server did not answer
 * for exists and will be there again in a moment. Told "not found", a room
 * retypes the address — the one action that cannot help — instead of reloading.
 * On a school network, where one refused request is ordinary, that is the
 * difference between a pause and a lost session.
 *
 * Only a 404 from the content itself is an address that is wrong. Everything
 * else — a 500, a connection that never opened, a body that would not parse —
 * says come back, and offers the button that does it.
 */
export function LoadFailed({ error }: { error: Error | null }) {
  const { ui } = useI18n();
  if (error instanceof ContentError && error.status === 404) return <NotFound />;
  return (
    <div className="catalog">
      <header className="cat-hero">
        <h1>{ui("failed.title")}</h1>
        <p className="lead">{ui("failed.body")}</p>
        <p className="lead">
          <button type="button" className="copy" onClick={() => location.reload()}>
            {ui("failed.retry")}
          </button>
        </p>
      </header>
    </div>
  );
}
